module.exports = __webpack_public_path__ + "img/logo2.f0e58a2a.webp";